import ReactTimeAgo from 'react-timeago'
import frenchStrings from 'react-timeago/lib/language-strings/fr'
import englishStrings from 'react-timeago/lib/language-strings/en'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import { useTranslation } from 'react-i18next'

const TimeAgo = ({ timestamp }) => {
  const { i18n } = useTranslation()
  const customStringsEn = {
    prefixFromNow: 'in',
    suffixAgo: '  ago',
    suffixFromNow: '',
    seconds: 'now',
    minute: 'm',
    minutes: '%dm',
    hour: 'h',
    hours: '%dh',
    day: 'd',
    days: '%dd',
    week: '%dw',
    weeks: '%dw',
    month: '%d Month',
    months: '%d Months',
    year: 'y',
    years: '%dy',
    wordSeparator: '',
    numbers: [],
  }
  const customStringsFr = {
    prefixAgo: 'il y a  ',
    prefixFromNow: 'dans',
    suffixFromNow: '',
    seconds: 'maintenant',
    minute: 'm',
    minutes: '%dm',
    hour: 'h',
    hours: '%dh',
    day: 'j',
    days: '%dj',
    week: '%ds',
    weeks: '%ds',
    month: '%d Mois',
    months: '%d Mois',
    year: '%da',
    years: '%da',
    wordSeparator: '',
    numbers: [],
  }
  const formatter = buildFormatter(i18n.language === 'fr' ? customStringsFr : customStringsEn)
  return <ReactTimeAgo date={timestamp} formatter={formatter} />
}

export default TimeAgo
